module.exports = __webpack_public_path__ + "img/btn_info.91fcc5c7.png";